<template>
  <div class="empty-wrap">
    <img class="img" src="~@/assets/images/v2/empty.png" alt="" />
    <div class="text">{{text}}</div>
  </div>
</template>

<script>
  export default {
    props: {
      text: {
        type: String,
        default: '暂无内容'
      }
    }
  }
</script>

<style lang="scss" scoped>
  .empty-wrap {
    padding: 70px 0;

    .img {
      display: block;
      width: 268px;
      height: 182px;
      margin: 0 auto;
    }

    .text {
      margin-top: 24px;
      color: #B3B5B9;
      font-size: 16px;
      text-align: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/saas/v2/Empty.vue